import { LocalizationService } from '../../../../../Core/Localization/services/localization.service';
import { Editor } from '@ckeditor/ckeditor5-core';


export class ToolbarStyleHelper {

    static readonly buttonDropdownNames = ['fontFamily', 'fontSize', 'lineHeight'];

    public static applyStyleChange(editor: Editor, toolbarConfigItems: any[], localizationService: LocalizationService): void {
        this.changeButtonDropdownsToLabelDropdowns(editor, toolbarConfigItems);
        this.removeMoreOptionButtonArrow(editor, toolbarConfigItems, localizationService);
        this.changeHTMLEditorButton(editor, toolbarConfigItems, localizationService);
        this.changeTooltipPosition(editor);
        this.adjustMoreOptionDropdownPanelPosition(editor, toolbarConfigItems);
    }

    private static changeButtonDropdownsToLabelDropdowns(editor: Editor, toolbarConfigItems: any[]): void {
        this.buttonDropdownNames.forEach((key: string) => {
            const index = toolbarConfigItems.indexOf(key);
            if (index > -1) {
                const toolbarItem = (editor.ui.view as any).toolbar.items.get(index);
                const command = editor.commands.get(key);
                toolbarItem.buttonView.withText = true;
                toolbarItem.buttonView.iconView.element.remove();
            }
        });
    }

    private static stringifyCamelCase(str: string): string {
        const result = str.replace(/([A-Z])/g, ' $1');
        return result.charAt(0).toUpperCase() + result.slice(1);
    }

    private static removeMoreOptionButtonArrow(editor: Editor, toolbarConfigItems: any[], localizationService: LocalizationService): void {
        const index = toolbarConfigItems.findIndex(x => x.icon === 'threeVerticalDots');
        if (index > -1) {
            (editor.ui.view as any).toolbar.items.get(index).buttonView.arrowView.element.remove();
            (editor.ui.view as any).toolbar.items.get(index).buttonView.label = localizationService.transform('Common.forms.richText.moreOptions');
        }
    }

    private static changeHTMLEditorButton(editor: Editor, toolbarConfigItems: any[], localizationService: LocalizationService): void {
        const index = toolbarConfigItems.indexOf('sourceEditing');
        if (index > -1) {
            const htmlEditor = (editor.ui.view as any).toolbar.items.get(index);
            htmlEditor.iconView?.element.remove();
            htmlEditor.class = 'agpr-html-editor-button fa-regular fa-code';
            htmlEditor.label = localizationService.transform('Common.forms.richText.htmlEditor');
        }
    }

    private static changeTooltipPosition(editor: Editor): void {
        (editor.ui.view as any).toolbar.items._items.forEach(view => {
            view = view.buttonView || view;
            view.tooltipPosition = 'n';
        });
    }

    static adjustMoreOptionDropdownPanelPosition(editor: Editor, toolbarConfigItems: any[]): void {
        const editorWidth = editor.ui.view.element.offsetWidth;
        const index = toolbarConfigItems.findIndex(x => x.icon === 'threeVerticalDots');
        let moreOptionDropdown;
        let moreOptionDropdownLeft = 0;
        if (index > -1) {
            moreOptionDropdown = (editor.ui.view as any).toolbar.items.get(index);
            moreOptionDropdownLeft = moreOptionDropdown.element.offsetLeft;
        }
        if (editorWidth && moreOptionDropdownLeft) {
            // the more option dropdown is too close to the right
            if (editorWidth - moreOptionDropdownLeft < 140) {
                moreOptionDropdown.panelPosition = 'sw';
            } else {
                moreOptionDropdown.panelPosition = 'se';
            }
        }
    }
}
